export const ACCOUNT_SECURITY_MINIMUM_AGE_DAYS = 14;

const accountSecurityMinimumAgeMs = ACCOUNT_SECURITY_MINIMUM_AGE_DAYS * 24 * 60 * 60 * 1000;

export function canManageAccountSecurity(
    createdAt: Date | string | null | undefined,
    currentTime = Date.now(),
): boolean {
    if (!createdAt) return false;

    const creationTime = new Date(createdAt).getTime();

    return Number.isFinite(creationTime) && currentTime - creationTime > accountSecurityMinimumAgeMs;
}
